import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FilePlus2, Search } from "lucide-react";
import { api } from "../lib/api";
import { SECTORS, SECTOR_LABELS } from "../data/wizardConfig";

const STATUS = {
    nuovo: { label: "Nuovo", cls: "badge-new" },
    in_valutazione: {
        label: "In valutazione",
        cls: "inline-flex items-center gap-1 bg-amber-100 text-amber-800 px-2.5 py-1 rounded-full text-xs font-bold",
    },
    risposto: { label: "Preventivo ricevuto", cls: "badge-replied" },
};

export default function QuotesList() {
    const [quotes, setQuotes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [q, setQ] = useState("");
    const [sector, setSector] = useState("all");

    useEffect(() => {
        api.get("/quotes")
            .then(({ data }) => setQuotes(data))
            .finally(() => setLoading(false));
    }, []);

    const filtered = quotes.filter((x) => {
        if (sector !== "all" && x.sector !== sector) return false;
        if (!q) return true;
        return (
            x.client_name?.toLowerCase().includes(q.toLowerCase()) ||
            x.id?.toLowerCase().includes(q.toLowerCase())
        );
    });

    return (
        <div className="max-w-5xl mx-auto" data-testid="quotes-list-page">
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-6">
                <div>
                    <h1 className="text-3xl font-black text-[#0C4650]">Le mie richieste</h1>
                    <p className="text-gray-600">Storico preventivi creati</p>
                </div>
                <Link to="/nuovo-preventivo" className="btn-primary" data-testid="new-quote-list">
                    <FilePlus2 className="w-4 h-4" /> Nuovo preventivo
                </Link>
            </div>

            <div className="card p-5 mb-6">
                <div className="flex flex-col sm:flex-row gap-3">
                    <div className="relative flex-1">
                        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
                        <input
                            value={q}
                            onChange={(e) => setQ(e.target.value)}
                            placeholder="Cerca per cliente..."
                            className="field pl-10"
                            data-testid="quotes-search"
                        />
                    </div>
                    <select
                        className="field sm:w-56"
                        value={sector}
                        onChange={(e) => setSector(e.target.value)}
                        data-testid="quotes-sector-filter"
                    >
                        <option value="all">Tutti i settori</option>
                        {Object.values(SECTORS).map((s) => (
                            <option key={s.key} value={s.key}>
                                {s.label}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            {loading ? (
                <div className="py-12 text-center text-gray-400">Caricamento…</div>
            ) : filtered.length === 0 ? (
                <div className="card p-12 text-center">
                    <p className="text-gray-600">Nessuna richiesta trovata.</p>
                </div>
            ) : (
                <div className="space-y-3">
                    {filtered.map((x) => (
                        <Link
                            key={x.id}
                            to={`/richieste/${x.id}`}
                            data-testid={`quote-link-${x.id}`}
                            className="card p-5 flex items-center justify-between gap-4 hover:shadow-md transition-all hover:-translate-y-0.5"
                        >
                            <div className="min-w-0">
                                <div className="flex items-center gap-2 flex-wrap">
                                    <span className="font-black text-[#0C4650] text-lg truncate">
                                        {x.client_name}
                                    </span>
                                    <span className={STATUS[x.status].cls}>
                                        {STATUS[x.status].label}
                                    </span>
                                </div>
                                <div className="text-sm text-gray-500 mt-1">
                                    {SECTOR_LABELS[x.sector] || SECTORS[x.sector]?.label} ·{" "}
                                    {new Date(x.created_at).toLocaleString("it-IT")}
                                </div>
                            </div>
                            <div className="text-[#0C4650] font-bold">→</div>
                        </Link>
                    ))}
                </div>
            )}
        </div>
    );
}
